import React from "react";

const STATES = {
  exploring: {
    label: "EXPLORING",
    sub: "Genuinely gathering the information you need.",
    color: "#10B981", bg: "rgba(16,185,129,0.12)", pos: 1,
  },
  enough_information: {
    label: "ENOUGH INFORMATION",
    sub: "You have enough to execute. More data now yields diminishing returns.",
    color: "#F59E0B", bg: "rgba(245,158,11,0.12)", pos: 2,
  },
  loop_forming: {
    label: "LOOP FORMING",
    sub: "You're circling the same decision. Another answer may not improve it.",
    color: "#FF6B35", bg: "rgba(255,107,53,0.14)", pos: 3,
  },
  decision_avoidance: {
    label: "DECISION AVOIDANCE",
    sub: "You're generating variations to delay confronting reality.",
    color: "#F43F5E", bg: "rgba(244,63,94,0.14)", pos: 4,
  },
};

export const ADVICE_STATES = STATES;

export default function AdviceMeter({ state = "exploring", compact = false, reconsiderations = 0 }) {
  const s = STATES[state] || STATES.exploring;
  return (
    <div data-testid="advice-meter" data-state={state} className="w-full">
      <div className="flex items-center justify-between">
        <span className="eyebrow">The Advice Meter</span>
        <span className="flex items-center gap-2">
          {reconsiderations > 0 && (
            <span className="font-mono2 text-[10px] uppercase tracking-wider text-neutral-500" data-testid="advice-meter-reconsiderations">
              {reconsiderations} of 3 reconsiderations
            </span>
          )}
          <span className="font-mono2 text-[10px] font-semibold uppercase tracking-wider" style={{ color: s.color }} data-testid="advice-meter-label">
            {s.label}
          </span>
        </span>
      </div>
      <div className="mt-2 flex gap-1.5">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="h-1.5 flex-1 rounded-full transition-all duration-500"
            style={{ background: i <= s.pos ? s.color : "rgba(255,255,255,0.08)" }}
          />
        ))}
      </div>
      {!compact && <p className="mt-2 text-xs text-neutral-500" data-testid="advice-meter-sub">{s.sub}</p>}
    </div>
  );
}
